import React from 'react';

export type BadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'default' | 'custom';

interface BadgeProps {
  label: string;
  variant?: BadgeVariant;
  className?: string;
  customBgColor?: string;  // Add custom background color prop
  customTextColor?: string;  // Add custom text color prop
}

const variantStyles: Record<BadgeVariant, string> = {
  success: 'bg-green-100 text-green-800',
  warning: 'bg-orange-100 text-secondary',
  error: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800',
  default: 'bg-gray-100 text-gray-800',
  custom: '' // Empty string for custom styling
};

export const Badge: React.FC<BadgeProps> = ({ 
  label, 
  variant = 'default',
  className = '',
  customBgColor,
  customTextColor
}) => {
  const style = variant === 'custom' ? {
    backgroundColor: customBgColor,
    color: customTextColor || '#000000'
  } : {};

  return (
    <span
      style={style}
      className={`px-2 py-1 text-xs font-semibold rounded inline-flex items-center
        ${variant !== 'custom' ? variantStyles[variant] : ''} ${className}`}
    >
      {label}
    </span>
  );
};

export default Badge;